import { useRef } from "react";

export const useDebouncer = (delay) => {
  const timeRef = useRef(null);
  const execute = (fn) => {
    if (timeRef.current) {
      clearTimeout(timeRef.current);
    }
    timeRef.current = setTimeout(fn, delay);
  };
  return execute;
};
